import React from 'react';
import './ModernFooter.css';

const ModernFooter = () => {
  return (
    <footer id="contacts" className="modern-footer">
      <div className="footer-background">
        <div className="footer-container">
          {/* Основная информация */}
          <div className="footer-main">
            <div className="footer-brand">
              <div className="footer-logo">
                <img src="/logo.svg" alt="Элеонора Тестова" className="footer-logo-img" />
              </div>
            </div>
            
            <div className="footer-contact-info">
              <a href="mailto:elyatestova31@mail.ru" className="footer-contact-item">
                <svg className="footer-contact-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M4 4H20C21.1 4 22 4.9 22 6V18C22 19.1 21.1 20 20 20H4C2.9 20 2 19.1 2 18V6C2 4.9 2.9 4 4 4Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M22 6L12 13L2 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                <span>elyatestova31@mail.ru</span>
              </a>
              <a href="tel:+79213606706" className="footer-contact-item">
                <svg className="footer-contact-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M22 16.92V19.92C22.0011 20.1985 21.9441 20.4742 21.8325 20.7293C21.7209 20.9845 21.5573 21.2136 21.3521 21.4019C21.1468 21.5901 20.9046 21.7335 20.6407 21.8227C20.3769 21.9119 20.0974 21.9451 19.82 21.92C16.7428 21.5856 13.787 20.5341 11.19 18.85C8.77382 17.3147 6.72533 15.2662 5.18999 12.85C3.49997 10.2412 2.44824 7.27099 2.11999 4.18C2.095 3.90347 2.12787 3.62476 2.21649 3.36162C2.30512 3.09849 2.44756 2.85669 2.63476 2.65162C2.82196 2.44655 3.0498 2.28271 3.30379 2.17052C3.55777 2.05833 3.83233 2.00026 4.10999 2H7.10999C7.59524 1.99522 8.06572 2.16708 8.43369 2.48353C8.80166 2.79999 9.04201 3.23945 9.10999 3.72C9.23662 4.68007 9.47144 5.62273 9.80999 6.53C9.94454 6.88792 9.97366 7.27691 9.8939 7.65088C9.81415 8.02485 9.62886 8.36811 9.35999 8.64L8.08999 9.91C9.51355 12.4135 11.5864 14.4864 14.09 15.91L15.36 14.64C15.6319 14.3711 15.9751 14.1858 16.3491 14.1061C16.7231 14.0263 17.1121 14.0555 17.47 14.19C18.3773 14.5286 19.3199 14.7634 20.28 14.89C20.7658 14.9585 21.2094 15.2032 21.5265 15.5775C21.8437 15.9518 22.0122 16.4296 22 16.92Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                <span>+7 (921) 360-67-06</span>
              </a>
            </div>
          </div>

          {/* Декоративные элементы */}
          {/* <div className="footer-decorative">
            <div className="footer-pattern">
              <div className="pattern-dot"></div>
              <div className="pattern-dot"></div>
              <div className="pattern-dot"></div>
              <div className="pattern-dot"></div>
              <div className="pattern-dot"></div>
            </div>
          </div> */}

          {/* Нижняя часть */}
          <div className="footer-bottom">
            <div className="footer-links">
              <span className="footer-link">Публичная оферта</span>
              <span className="footer-divider">•</span>
              <span className="footer-link">Политика конфиденциальности</span>
            </div>
            
            <div className="footer-copyright">
              <p>© 2025 Элеонора Тестова. Все права защищены.</p>
            </div>
          </div>
        </div>

        {/* Анимированный фон */}
        <div className="footer-bg-pattern">
          <div className="bg-circle circle-1"></div>
          <div className="bg-circle circle-2"></div>
          <div className="bg-circle circle-3"></div>
        </div>
      </div>
    </footer>
  );
};

export default ModernFooter; 